<template>
  <b-modal id="loginDialog" title="Anmelden" ok-only ok-variant="secondary" ok-title="Anmelden" @ok="login()">
    <b-form>
      <b-form-group label="Benutzername" label-for="login.user">
        <b-form-input
          id="login.user"
          v-model="username"
          type="text"
          required
        ></b-form-input>
      </b-form-group>
      <b-form-group label="Passwort" login-for="login.password">
        <b-form-input
          id="login.password"
          v-model="password"
          type="password"
          required
          v-on:keydown.enter="loginEnter"
        ></b-form-input>
      </b-form-group>
    </b-form>
  </b-modal>
</template>

<script>
import security from '@/modules/security.js'

export default {
  name: 'LoginDialog',
  data() {
    return {
      username: "",
      password: ""
    }
  },
  methods: {
    loginEnter: function() {
      this.login();
      console.log('try to hide',this.$bvModal);
      this.$bvModal.hide('loginDialog');
    },
    login: function() {
      console.log('login');
      security.login(this.username,this.password);
      this.username = '';
      this.password = '';
    }
  }
}
</script>
